import { render, staticRenderFns } from "./RootComponent.vue?vue&type=template&id=7b69f211&"
import script from "./RootComponent.vue?vue&type=script&lang=js&"
export * from "./RootComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports